import {useRouteLoaderData} from '@remix-run/react'

import {useReportWidgetSeen} from '~/hooks/analytic-hooks'
import {FlagIconByLocale} from '~/icons/flag-icons-by-locale'
import {getTranslation} from '~/localization/translation'
import type {RootLoaderResponse} from '~/types'

const ShippingEUSection = () => {
  const {locale, language} = useRouteLoaderData('root') as RootLoaderResponse
  const translations = getTranslation(language)

  const [widgetRef] = useReportWidgetSeen({
    widget_name: 'shipping-section-eu',
    widget_place: 'middle',
  })

  return (
    <div ref={widgetRef}>
      <div className="border-gray relative z-20 flex h-full w-full flex-row items-center justify-center gap-2 overflow-hidden rounded-2xl border bg-white px-4 py-4 text-center text-base font-medium shadow-md tablet:items-start tablet:justify-start tablet:text-start">
        <FlagIconByLocale locale={locale?.toLowerCase()} className="shrink-0 tablet:mt-1" />
        {translations.ShippingSection.title}
      </div>
    </div>
  )
}

export default ShippingEUSection
